import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { useNavigate } from "react-router-dom";

const DataTableTransfertsEntreCompte = ({ data, title }) => {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const { SearchBar } = Search;


  function buttonPlusFormatter(cell, row) {
    return (
      <span style={{ display: "flex", justifyContent: "center" }}>
        <button
          style={{ width: 40 }}
          className="btn bg-black btn-sm"
          onClick={() => {
            sessionStorage.setItem("infoId", row.id);
            navigate('/transfertEntreComptesPusInfo')

          }}
        >
          <i className="fas fa-eye"></i>
        </button>
      </span>
    );
  }

  // Table columns
  const columns = [
    {
      dataField: "ref",
      text: "Référence",
      headerAlign: "center",
      headerStyle: { width: "10%" },
    },
    {
      dataField: "name",
      text: "Nom",
      headerAlign: "center",
    },
    {
      dataField: "year",
      text: "Année",
      headerAlign: "center",
      sort: true, // Activer le tri pour la colonne Année de Date
    },
    {
      dataField: "date",
      text: "Date",
      headerAlign: "center",
      sort: true, // Activer le tri pour la colonne Année de Date
    },
    {
      dataField: "sourceBanqueAccount",
      text: "Source",
      headerAlign: "center",
      formatter: (cell) => `${cell.bankAccountNumber} - ${cell.name}`
    },
    {
      dataField: "destinationBanqueAccount",
      text: "Destination",
      headerAlign: "center",
      formatter: (cell) => `${cell.bankAccountNumber} - ${cell.name}`
    },
    {
      dataField: "amount",
      text: "Montant",
      headerAlign: "center",
      formatter: (cell) => `${cell.toFixed(2)}`,
      align: "center", // Aligner les montants à droite pour une meilleure lisibilité
    },
    {
      dataField: "additionalInfo",
      text: "Plus d'Info",
      headerAlign: "center",
      formatter: buttonPlusFormatter,
    },
  ];


  return (
    <div className="card card-dark">
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        {/* {stateDocument()} */}
      </div>
      <div className="card-body">
        <ToolkitProvider
          keyField="ref"
          data={data}
          columns={columns}
          search
        >
          {(props) => (
            <div>
              <SearchBar {...props.searchProps} placeholder="Search..." />
              <BootstrapTable
                {...props.baseProps}
                pagination={paginationFactory()}
                striped
                hover
              />
            </div>
          )}
        </ToolkitProvider>
      </div>
    </div>

  );
};

export default DataTableTransfertsEntreCompte;
